import { CommonConstants } from "../../common/constants/common-constants";
import { IAPIResponse, IHTTPResponse } from "../../common/models/httpModels";
import { HTTPService } from "../../common/services/httpService";
import { ICertificationDeleteRequest, ICertificationGenerateRequest, IProgressReportFile } from "./schoolCertificationModel";

const httpService = new HTTPService();
const fileUpload = (files: File[]): Promise<IHTTPResponse<IAPIResponse<any>>> => {
    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.ProgressCardFileUpload
        }`;
    const formData = new FormData();
    files.forEach((file) => { formData.append('files', file) });

  

    return httpService.fileUpload(url, formData);
};

const getFiles = (): Promise<IHTTPResponse<IAPIResponse<IProgressReportFile>>> => {
    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.ProgressCardList}`;

    return httpService.get(url);
}

const deleteFile = (deleteFileRequest: ICertificationDeleteRequest): Promise<IHTTPResponse<IAPIResponse<IProgressReportFile>>> => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.ProgressCardFileDelete}`;

    return httpService.post(url, deleteFileRequest);
}

const generateProgressCardFile = (certificateGenerateRequest: ICertificationGenerateRequest): Promise<IHTTPResponse<IAPIResponse<IProgressReportFile>>> => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.ProgressCardGenerate}`;

    return httpService.post(url, certificateGenerateRequest);
}

const getStudentFileDownloadUrl = (fileId: number): string => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.ProgressCardDownloadStudentFile}/${fileId}`;

    return url;
}

const getHallTicketFileDownloadUrl = (fileId: number): string => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.ProgressCardDownloadHallTicketFile}/${fileId}`;

    return url;
}

const ProgressCardService = {
    fileUpload,
    getFiles,
    deleteFile,
    getStudentFileDownloadUrl,
    getHallTicketFileDownloadUrl,
    generateProgressCardFile
};

export default ProgressCardService;